export enum AgentType {
    GPT = 'gpt',
    GEMINI = 'gemini',
    GROK = 'grok',
}

export const AI_AUDIO_AGENTS = [AgentType.GPT, AgentType.GEMINI, AgentType.GROK] as const;

export function isAiAudioAgent(agent: string): boolean {
    return AI_AUDIO_AGENTS.includes(agent.toLowerCase() as AgentType);
}

export function isAgentMediaType(type: string): boolean {
    return type.match(/image|audio|video\/(gemini|gpt|grok)/i) ? true : false;
}

